<ag-grid-angular class="data-grid " [rowData]="data$ | async" [gridOptions]="gridOptions" [attr.aria-label]="widgetTitle"></ag-grid-angular>